import React from 'react';
import './Pages/PagesCss/LegalInformation.css';

const TermsConditions = () => {
  return (
    <div className="privacy-policy">
      {/* Header Section */}
      <section className="policy-header">
        <div className="container">
          <div className="header-content">
            <h1>Terms & Conditions</h1>
            <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            <p className="header-description">
              Welcome to Font-Max! These Terms & Conditions govern your use of our text processing 
              and font generation tools. By accessing or using our services, you agree to be bound by these terms.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="policy-content">
        <div className="container-one">
          <div className="policy-grid">
            {/* Table of Contents */}
            <aside className="table-of-contents">
              <h3>Table of Contents</h3>
              <div>
                <ul>
                  <li><a href="#acceptance-terms">Acceptance of Terms</a></li>
                  <li><a href="#service-description">Service Description</a></li>
                  <li><a href="#user-responsibilities">User Responsibilities</a></li>
                  <li><a href="#intellectual-property">Intellectual Property</a></li>
                  <li><a href="#prohibited-activities">Prohibited Activities</a></li>
                  <li><a href="#limitation-liability">Limitation of Liability</a></li>
                  <li><a href="#service-availability">Service Availability</a></li>
                  <li><a href="#third-party-links">Third-Party Links</a></li>
                  <li><a href="#termination">Termination</a></li>
                  <li><a href="#governing-law">Governing Law</a></li>
                  <li><a href="#changes-terms">Changes to Terms</a></li>
                  <li><a href="#contact-us">Contact Us</a></li>
                </ul>
              </div>
            </aside>

            {/* Terms Sections */}
            <div className="policy-sections">
              <section id="acceptance-terms" className="policy-section">
                <h2>1. Acceptance of Terms</h2>
                <div className="section-content">
                  <p>
                    This Terms & Conditions applies to all websites and subdomains operated by D-Tech Studios for Font-Max, including <a href="https://font-max.com" target="_blank" rel="noopener noreferrer">https://font-max.com</a>,
                    you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions. 
                    If you do not agree with any part of these terms, you must not use our services.
                  </p>
                  <p>
                    These terms apply to all visitors, users, and others who access or use our text processing tools 
                    and font generation services.
                  </p>
                </div>
              </section>

              <section id="service-description" className="policy-section">
                <h2>2. Service Description</h2>
                <div className="section-content">
                  <p>Font-Max provides a collection of online text processing tools including but not limited to:</p>
                  
                  <div className="tools-categories">
                    <h3>2.1 Available Tools</h3>
                    <ul>
                      <li><strong>Style Tools:</strong> Font Generator, Emojis Generator, Symbols Generator, Font Finder</li>
                      <li><strong>Conversion Tools:</strong> Sentence Case Converter, Text Reverse, Text To Binary, ROT13 Converter</li>
                      <li><strong>Analysis Tools:</strong> Word Counter, Keyword Density Checker, Readability Checker</li>
                      <li><strong>Cleaning Tools:</strong> Duplicate Line Remover, Whitespace Remover, Code Snippet Cleaner</li>
                      <li><strong>Encoding Tools:</strong> Base64 Encoder/Decoder, URL Encoder/Decoder, Morse Code Converter</li>
                      <li><strong>Sorting Tools:</strong> Alphabetical Sorter, Numeric Sorter, Date Sorter</li>
                    </ul>
                  </div>

                  <h3>2.2 Service Limitations</h3>
                  <p>
                    Our tools are provided for convenience and general use. While we strive for accuracy, 
                    we cannot guarantee that the results will always be perfect or suitable for your specific needs. 
                    Some processing may occur server-side, but we prioritize local processing when possible.
                  </p>
                </div>
              </section>

              <section id="user-responsibilities" className="policy-section">
                <h2>3. User Responsibilities</h2>
                <div className="section-content">
                  <h3>3.1 Account Security (If Applicable)</h3>
                  <p>If account registration becomes available, you are responsible for:</p>
                  <ul>
                    <li>Maintaining the confidentiality of your account credentials</li>
                    <li>All activities that occur under your account</li>
                    <li>Notifying us immediately of any unauthorized use</li>
                  </ul>

                  <h3>3.2 Appropriate Use</h3>
                  <p>You agree to use our services:</p>
                  <ul>
                    <li>In compliance with all applicable laws and regulations</li>
                    <li>For lawful purposes only</li>
                    <li>Without disrupting the service or infrastructure</li>
                    <li>Respecting other users' rights and privacy</li>
                  </ul>

                  <h3>3.3 Content Responsibility</h3>
                  <p>
                    You are solely responsible for the text content you process through our tools. 
                    We do not claim ownership of your input or output text.
                  </p>
                </div>
              </section>

              <section id="intellectual-property" className="policy-section">
                <h2>4. Intellectual Property</h2>
                <div className="section-content">
                  <h3>4.1 Our Intellectual Property</h3>
                  <p>
                    All rights, title, and interest in and to the Font-Max website, tools, software, 
                    and any content provided by us (excluding user-generated content) are and will remain 
                    the exclusive property of D-Tech Studios and its licensors.
                  </p>

                  <h3>4.2 User Content</h3>
                  <p>
                    You retain all rights to the text content you input into our tools. By using our services, 
                    you grant us a limited license to process your text solely for the purpose of providing 
                    the requested service.
                  </p>

                  <h3>4.3 Generated Content</h3>
                  <p>
                    Font styles, symbols, and other generated content may be subject to third-party intellectual 
                    property rights. You are responsible for ensuring your use of generated content complies with 
                    applicable licenses and laws.
                  </p>
                </div>
              </section>

              <section id="prohibited-activities" className="policy-section">
                <h2>5. Prohibited Activities</h2>
                <div className="section-content">
                  <p>You agree not to use our services for any of the following prohibited activities:</p>
                  
                  <div className="prohibited-list">
                    <h3>5.1 Illegal Activities</h3>
                    <ul>
                      <li>Processing content that violates any laws or regulations</li>
                      <li>Generating fraudulent or malicious content</li>
                      <li>Engaging in hacking, phishing, or other cybercrimes</li>
                    </ul>

                    <h3>5.2 Harmful Content</h3>
                    <ul>
                      <li>Processing malicious code, viruses, or harmful scripts</li>
                      <li>Generating spam, phishing content, or deceptive materials</li>
                      <li>Creating content that promotes violence, hate speech, or harassment</li>
                    </ul>

                    <h3>5.3 Service Abuse</h3>
                    <ul>
                      <li>Attempting to overload or disrupt our services</li>
                      <li>Automated scraping or data extraction without permission</li>
                      <li>Reverse engineering or decompiling our software</li>
                      <li>Using our services to compete with Font-Max</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section id="limitation-liability" className="policy-section">
                <h2>6. Limitation of Liability</h2>
                <div className="section-content">
                  <h3>6.1 No Warranty</h3>
                  <p>
                    Our services are provided "as is" and "as available" without warranties of any kind, 
                    either express or implied. We do not warrant that:
                  </p>
                  <ul>
                    <li>The services will be uninterrupted or error-free</li>
                    <li>The results will meet your specific requirements</li>
                    <li>The tools will be available at all times</li>
                  </ul>

                  <h3>6.2 Limitation of Damages</h3>
                  <p>
                    To the fullest extent permitted by law, D-Tech Studios shall not be liable for any indirect, 
                    incidental, special, consequential, or punitive damages, including but not limited to:
                  </p>
                  <ul>
                    <li>Loss of profits, data, or business opportunities</li>
                    <li>Damages resulting from service interruptions</li>
                    <li>Costs of substitute goods or services</li>
                    <li>Any damages related to your use of generated content</li>
                  </ul>

                  <h3>6.3 Maximum Liability</h3>
                  <p>
                    Our total cumulative liability to you for all claims arising from or related to these terms 
                    or your use of our services shall not exceed the amount you have paid us (if any) in the 
                    last six months, or $10, whichever is greater.
                  </p>
                </div>
              </section>

              <section id="service-availability" className="policy-section">
                <h2>7. Service Availability</h2>
                <div className="section-content">
                  <p>
                    We strive to maintain 24/7 availability of our services but do not guarantee uninterrupted access. 
                    We may temporarily suspend services for:
                  </p>
                  <ul>
                    <li>Scheduled maintenance and updates</li>
                    <li>Emergency repairs and security updates</li>
                    <li>Technical issues beyond our control</li>
                    <li>Excessive load or abuse prevention</li>
                  </ul>
                  <p>
                    We will make reasonable efforts to notify users of planned maintenance when possible, 
                    but emergency maintenance may occur without prior notice.
                  </p>
                </div>
              </section>

              <section id="third-party-links" className="policy-section">
                <h2>8. Third-Party Links and Services</h2>
                <div className="section-content">
                  <p>
                    Our website may contain links to third-party websites or services that are not owned or 
                    controlled by D-Tech Studios. We have no control over, and assume no responsibility for:
                  </p>
                  <ul>
                    <li>The content, privacy policies, or practices of any third-party sites</li>
                    <li>Any damages or losses caused by third-party services</li>
                    <li>The accuracy or reliability of third-party content</li>
                  </ul>
                  <p>
                    You acknowledge and agree that D-Tech Studios shall not be responsible or liable, directly 
                    or indirectly, for any damage or loss caused by or in connection with use of any third-party content.
                  </p>
                </div>
              </section>

              <section id="termination" className="policy-section">
                <h2>9. Termination</h2>
                <div className="section-content">
                  <h3>9.1 By You</h3>
                  <p>
                    You may stop using our services at any time. If account features are available, 
                    you may delete your account through the provided means.
                  </p>

                  <h3>9.2 By Us</h3>
                  <p>
                    We may terminate or suspend your access to our services immediately, without prior notice 
                    or liability, for any reason whatsoever, including but not limited to:
                  </p>
                  <ul>
                    <li>Breach of these Terms & Conditions</li>
                    <li>Engaging in prohibited activities</li>
                    <li>Requests by law enforcement or government agencies</li>
                    <li>Security or technical issues</li>
                    <li>Extended periods of inactivity</li>
                  </ul>
                </div>
              </section>

              <section id="governing-law" className="policy-section">
                <h2>10. Governing Law</h2>
                <div className="section-content">
                  <p>
                    These Terms & Conditions shall be governed and construed in accordance with the laws of 
                    the State of Texas, United States, without regard to its conflict of law provisions.
                  </p>
                  <p>
                    Any disputes arising from these terms or your use of our services shall be resolved in 
                    the state or federal courts located in Galveston County, Texas.
                  </p>
                  <p>
                    If you are accessing our services from outside the United States, you are responsible for 
                    compliance with local laws in addition to these terms.
                  </p>
                </div>
              </section>

              <section id="changes-terms" className="policy-section">
                <h2>11. Changes to Terms</h2>
                <div className="section-content">
                  <p>
                    We reserve the right, at our sole discretion, to modify or replace these Terms & Conditions 
                    at any time. If a revision is material, we will provide at least 30 days' notice prior to 
                    any new terms taking effect.
                  </p>
                  <p>
                    By continuing to access or use our services after any revisions become effective, 
                    you agree to be bound by the revised terms. If you do not agree to the new terms, 
                    you must stop using our services.
                  </p>
                  <p>
                    We will update the "Last updated" date at the top of this page when changes are made.
                  </p>
                </div>
              </section>

              <section id="contact-us" className="policy-section">
                <h2>12. Contact Us</h2>
                <div className="section-content">
                  <p>If you have any questions about these Terms & Conditions, please contact us:</p>
                  <div className="contact-info">
                    <div className="contact-item">
                      <strong>Email:</strong> support@font-max.com
                    </div>
                    <div className="contact-item">
                      <strong>Address:</strong> 2568 Madison Ave, League City, TX 77573
                    </div>
                    <div className="contact-item">
                      <strong>Website:</strong> <a href="https://font-max.com">https://font-max.com</a>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Actions */}
      <section className="policy-actions">
        <div className="container">
          <div className="actions-content">
            <h3>Questions About Our Terms?</h3>
            <p>If you have any questions about our Terms & Conditions or how to use our services properly, we're here to help.</p>
            <div className="action-buttons">
              <a href="/Contact" className="btn btn-primary">Contact Us</a>
              <a href="/WordCounter" className="btn btn-secondary">Explore Our Tools</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;